import { createSystem, defineConfig } from '@chakra-ui/react';
import { defaultThemeConfig } from 'core/ui-next/theme/defaultThemeConfig';

const config = defineConfig({
	theme: {
		breakpoints: {
			'phone-md': '376px',
			'phone-lg': '425px'
		},
	},

	globalCss: {

		'body': {
			'--scrollbar-track': '{colors.scrollbar.track}',
			'--scrollbar-thumb': '{colors.scrollbar.thumb}',
			'--scrollbar-width': '0.5rem',
			'--scrollbar-height': '0.5rem',
		},

		// Hay un problema. En cuanto le doy el estilo al scrollbar, se vuelve visible en Android,
		// en lugar de respetar el comportamiento por defecto de aparecer sólo durante el scroll.
		// Sin embargo, quiero que el PC, cuando la configuración de barras de scroll sea auto y
		// se muestren siempre (que es lo que hace un PC), tengan este aspecto.
		// Para ello, aplico la regla sólo en dispositivos de tipo PC
		'.theme-pos *::-webkit-scrollbar': {
			width: 'var(--scrollbar-width)',
			height: 'var(--scrollbar-height)',
		},

		/* Modo ocultar scrollbars */
		'.hide-scrollbars *::-webkit-scrollbar': {
			display: 'none'
		},

		/* Modo mostrar scrollbars */
		'.show-scrollbars *::-webkit-scrollbar': {
			display: 'block',

			// Cuando se muestran, fuerzo el tamaño. No se le va a aplicar la regla general
			// porque sólo se usa en theme-pos, y podríamos querer que en un android/ios
			// se mostrasen siempre las barras de scroll (como hacemos en los KDS), en cuyo
			// caso queremos mantener el aspecto de Ágora.
			width: 'var(--scrollbar-width)',
			height: 'var(--scrollbar-height)',
		},

		'::-webkit-scrollbar-track': { backgroundColor: 'var(--scrollbar-track)' },
		'::-webkit-scrollbar-thumb': {
			borderRadius: '0.5rem',
			border: '2px solid transparent',
			backgroundClip: 'content-box',
			backgroundColor: 'var(--scrollbar-thumb)',
		},

	}
});

export default createSystem(defaultThemeConfig, config);
